export const SUPPORT_PRIORITIES = [
  { value: "faible", label: "Faible", emoji: "🟢" },
  { value: "moyenne", label: "Moyenne", emoji: "🟡" },
  { value: "haute", label: "Haute", emoji: "🟠" },
  { value: "critique", label: "Critique", emoji: "🔴" },
];

export const getSupportPriorityDisplay = (priority) => {
  const match = SUPPORT_PRIORITIES.find((item) => item.value === priority);
  return match ? `${match.emoji} ${match.label}` : priority || "—";
};

export const SUPPORT_ISSUE_STARTED_OPTIONS = [
  { value: "just_now", label: "Just now" },
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "within_7_days", label: "Within the last 7 days" },
  { value: "more_than_week", label: "More than a week ago" },
  { value: "more_than_month", label: "More than a month ago" },
  { value: "unknown", label: "I don't know" },
];

export const getSupportIssueStartedDisplay = (issueStarted) => {
  const match = SUPPORT_ISSUE_STARTED_OPTIONS.find((item) => item.value === issueStarted);
  return match?.label || issueStarted || "—";
};

export const SUPPORT_CONTACT_METHODS = [
  { value: "email", label: "Email", emoji: "✉️" },
  { value: "phone", label: "Phone", emoji: "📞" },
  { value: "linkedin", label: "LinkedIn", emoji: "💼" },
  { value: "whatsapp", label: "WhatsApp", emoji: "💬" },
  { value: "telegram", label: "Telegram", emoji: "✈️" },
];

export const getSupportContactMethodDisplay = (method) => {
  const match = SUPPORT_CONTACT_METHODS.find((item) => item.value === method);
  return match ? `${match.emoji} ${match.label}` : method || "—";
};

export const SUPPORT_TYPES = [
  { value: "bug", label: "Bug", emoji: "🐞" },
  { value: "account", label: "Account", emoji: "👤" },
  { value: "payment_subscription", label: "Payment / Subscription", emoji: "💳", subcategoryLabel: "Billing & Subscription" },
  { value: "reports", label: "Reports", emoji: "📊" },
  { value: "notifications", label: "Notifications", emoji: "🔔" },
  { value: "feature_request", label: "Feature Request", emoji: "💡" },
  { value: "question_assistance", label: "Question / Assistance", emoji: "❓" },
  { value: "security", label: "Security", emoji: "🔒" },
  { value: "performance", label: "Performance", emoji: "⚡" },
  { value: "synchronization", label: "Synchronization", emoji: "🔄" },
  { value: "mobile_app", label: "Mobile App", emoji: "📱" },
  { value: "other", label: "Other", emoji: "📎" },
];

export const SUPPORT_SUBCATEGORIES = {
  bug: [
    { value: "application_crashes", label: "Application crashes" },
    { value: "feature_not_working", label: "Feature not working" },
    { value: "data_not_saving", label: "Data not saving" },
    { value: "incorrect_information", label: "Incorrect information displayed" },
    { value: "ui_layout_issue", label: "UI/Layout issue" },
    { value: "error_message", label: "Error message" },
    { value: "other", label: "Other" },
  ],
  account: [
    { value: "unable_to_sign_in", label: "Unable to sign in" },
    { value: "password_reset_issue", label: "Password reset issue" },
    { value: "email_verification_issue", label: "Email verification issue" },
    { value: "profile_update_issue", label: "Profile update issue" },
    { value: "permission_roles_issue", label: "Permission/Roles issue" },
    { value: "account_locked", label: "Account locked" },
    { value: "other", label: "Other" },
  ],
  payment_subscription: [
    { value: "payment_failed", label: "Payment failed" },
    { value: "subscription_issue", label: "Subscription issue" },
    { value: "invoice_issue", label: "Invoice issue" },
    { value: "refund_request", label: "Refund request" },
    { value: "upgrade_downgrade", label: "Upgrade/Downgrade subscription" },
    { value: "cancel_subscription", label: "Cancel subscription" },
    { value: "other", label: "Other" },
  ],
  reports: [
    { value: "report_not_loading", label: "Report not loading" },
    { value: "incorrect_report_data", label: "Incorrect report data" },
    { value: "missing_data", label: "Missing data" },
    { value: "export_issue", label: "Export issue" },
    { value: "dashboard_statistics_issue", label: "Dashboard statistics issue" },
    { value: "other", label: "Other" },
  ],
  notifications: [
    { value: "email_notification_issue", label: "Email notification issue" },
    { value: "push_notification_issue", label: "Push notification issue" },
    { value: "sms_notification_issue", label: "SMS notification issue" },
    { value: "notification_delay", label: "Notification delay" },
    { value: "notification_settings_issue", label: "Notification settings issue" },
    { value: "other", label: "Other" },
  ],
  feature_request: [
    { value: "new_feature_request", label: "New feature request" },
    { value: "improve_existing_feature", label: "Improve existing feature" },
    { value: "ui_improvement", label: "User interface improvement" },
    { value: "new_report_request", label: "New report request" },
    { value: "integration_request", label: "Integration request" },
    { value: "other", label: "Other" },
  ],
  question_assistance: [
    { value: "how_to_use_feature", label: "How to use a feature" },
    { value: "configuration_assistance", label: "Configuration assistance" },
    { value: "setup_assistance", label: "Setup assistance" },
    { value: "general_question", label: "General question" },
    { value: "best_practices", label: "Best practices" },
    { value: "other", label: "Other" },
  ],
  security: [
    { value: "unauthorized_access", label: "Unauthorized access" },
    { value: "suspicious_activity", label: "Suspicious activity" },
    { value: "permission_issue", label: "Permission issue" },
    { value: "two_factor_issue", label: "Two-factor authentication issue" },
    { value: "security_vulnerability", label: "Security vulnerability" },
    { value: "other", label: "Other" },
  ],
  performance: [
    { value: "slow_application", label: "Slow application" },
    { value: "slow_page_loading", label: "Slow page loading" },
    { value: "timeout_issue", label: "Timeout issue" },
    { value: "high_resource_usage", label: "High resource usage" },
    { value: "performance_degradation", label: "Performance degradation" },
    { value: "other", label: "Other" },
  ],
  synchronization: [
    { value: "data_not_synchronized", label: "Data not synchronized" },
    { value: "delayed_synchronization", label: "Delayed synchronization" },
    { value: "duplicate_data", label: "Duplicate data" },
    { value: "missing_data", label: "Missing data" },
    { value: "api_synchronization_issue", label: "API synchronization issue" },
    { value: "other", label: "Other" },
  ],
  mobile_app: [
    { value: "app_crashes", label: "App crashes" },
    { value: "feature_not_working", label: "Feature not working" },
    { value: "login_issue", label: "Login issue" },
    { value: "push_notification_issue", label: "Push notification issue" },
    { value: "sync_issue", label: "Sync issue" },
    { value: "ui_layout_issue", label: "UI/Layout issue" },
    { value: "other", label: "Other" },
  ],
};

export const LEGACY_SUPPORT_TYPES = {
  "user experience": { label: "User Experience", emoji: "💡" },
  "user interface": { label: "User Interface", emoji: "🎨" },
};

export const SUPPORT_TYPE_BADGE_COLORS = {
  bug: "danger",
  account: "dark",
  payment_subscription: "primary",
  reports: "info",
  notifications: "secondary",
  feature_request: "success",
  question_assistance: "primary",
  security: "dark",
  performance: "secondary",
  synchronization: "info",
  mobile_app: "primary",
  other: "warning",
  "user experience": "primary",
  "user interface": "info",
};

export const getSupportTypeMeta = (type) => {
  const match = SUPPORT_TYPES.find((item) => item.value === type);
  if (match) return match;
  return LEGACY_SUPPORT_TYPES[type] || null;
};

export const getSupportSubcategories = (type) => SUPPORT_SUBCATEGORIES[type] || [];

export const typeHasSubcategories = (type) => getSupportSubcategories(type).length > 0;

export const getSupportSubcategoryLabel = (type, subcategory, customSubcategory = "") => {
  if (!subcategory) return "";
  if (subcategory === "other" && customSubcategory?.trim()) {
    return customSubcategory.trim();
  }
  const match = getSupportSubcategories(type).find((item) => item.value === subcategory);
  return match?.label || subcategory;
};

export const getSupportTypeGroupLabel = (type) => {
  const meta = getSupportTypeMeta(type);
  if (!meta) return type || "Unknown";
  const label = meta.subcategoryLabel || meta.label;
  return `${meta.emoji} ${label}`;
};

export const getSupportTypeDisplay = (
  type,
  customType = "",
  subcategory = "",
  customSubcategory = ""
) => {
  if (type === "other" && customType?.trim()) {
    return `📎 Other: ${customType.trim()}`;
  }
  const meta = getSupportTypeMeta(type);
  const typeLabel = meta ? `${meta.emoji} ${meta.label}` : type || "Unknown";
  const subLabel = getSupportSubcategoryLabel(type, subcategory, customSubcategory);
  if (subLabel) return `${typeLabel} · ${subLabel}`;
  return typeLabel;
};

export const SUPPORT_TYPE_CHART_COLORS = {
  bug: "#F06B8F",
  account: "#8B5CF6",
  payment_subscription: "#3B82F6",
  reports: "#6366F1",
  notifications: "#14B8A6",
  feature_request: "#22C55E",
  question_assistance: "#6B9DFE",
  security: "#EF4444",
  performance: "#F59E0B",
  synchronization: "#06B6D4",
  mobile_app: "#EC4899",
  other: "#FFB454",
  "user experience": "#6B9DFE",
  "user interface": "#4ECDC4",
};

export const getSupportTypeChartColor = (type) =>
  SUPPORT_TYPE_CHART_COLORS[type] || "#B8C5D6";
